import React from 'react'

import { cn } from '@/lib/utils'

type Props = Omit<React.ComponentProps<'div'>, 'children'> & {
  message: string
}

const HRMessage: React.FC<Props> = ({ className, message, ...props }) => (
  <div
    className={cn(
      'block overflow-hidden text-center whitespace-nowrap',
      className,
    )}
    {...props}
  >
    <span
      className="relative inline-block before:absolute before:top-1/2
        before:right-full before:mr-3.75 before:h-px before:w-2499.75
        before:bg-[#ced4da] before:content-[''] after:absolute after:top-1/2
        after:left-full after:ml-3.75 after:h-px after:w-2499.75
        after:bg-[#ced4da] after:content-['']"
    >
      {message}
    </span>
  </div>
)

export default HRMessage
